import { useMutation, useQuery } from "./urqlHooks";
import { toAbsoluteDownloadUrl } from "src/utils/toAbsoluteDownloadUrl";
import { getUrqlTenantCompanyId } from "./tenantCompanyId";

export const ENTITY_ATTACHMENT_MAX_MB = 5;

export const GET_ENTITY_ATTACHMENT_UPLOAD_URL = `query GET_ENTITY_ATTACHMENT_UPLOAD_URL($entityId: String!, $entityType: EntityAttachmentType!, $fileName: String!, $fileType: String!, $companyId: String!) {
  getEntityAttachmentUploadUrl(entityId: $entityId, entityType: $entityType, fileName: $fileName, fileType: $fileType, companyId: $companyId) {
    uploadUrl
    fileId
    storageFileName
  }
}`;

export const SAVE_ENTITY_ATTACHMENT = `mutation SAVE_ENTITY_ATTACHMENT($input: SaveEntityAttachmentInput!, $companyId: String!) {
  saveEntityAttachment(input: $input, companyId: $companyId) {
    fileName
    originalFileName
    uploadedAt
    uploadedBy
  }
}`;

export const DELETE_ENTITY_ATTACHMENT = `mutation DELETE_ENTITY_ATTACHMENT($input: DeleteEntityAttachmentInput!, $companyId: String!) {
  deleteEntityAttachment(input: $input, companyId: $companyId)
}`;

export const GET_ENTITY_ATTACHMENT_DOWNLOAD_URL = `query GET_ENTITY_ATTACHMENT_DOWNLOAD_URL($entityId: String!, $entityType: EntityAttachmentType!, $fileName: String!, $companyId: String!) {
  getEntityAttachmentDownloadUrl(entityId: $entityId, entityType: $entityType, fileName: $fileName, companyId: $companyId)
}`;

export const GetEntityAttachmentUploadUrl = () => {
  const [result, executeQuery] = useQuery({
    query: GET_ENTITY_ATTACHMENT_UPLOAD_URL,
    pause: true,
  });
  return { ...result, executeQuery };
};

export const SaveEntityAttachment = () => {
  const [result, executeMutation] = useMutation(SAVE_ENTITY_ATTACHMENT);
  return { ...result, executeMutation };
};

export const DeleteEntityAttachment = () => {
  const [result, executeMutation] = useMutation(DELETE_ENTITY_ATTACHMENT);
  return { ...result, executeMutation };
};

export const GetEntityAttachmentDownloadUrl = ({ entityId, entityType, fileName }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_ENTITY_ATTACHMENT_DOWNLOAD_URL,
    variables: { entityId, entityType, fileName },
    pause: !entityId || !entityType || !fileName,
  });
  return { ...result, reexecuteQuery };
};

function getGraphqlUrl() {
  return process.env.REACT_APP_API_URL || "http://localhost:3000/graphql";
}

function buildGraphqlAuthHeaders() {
  const headers = { "Content-Type": "application/json" };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function fetchEntityAttachmentUploadUrl({ entityId, entityType, fileName, fileType }) {
  const response = await fetch(getGraphqlUrl(), {
    method: "POST",
    headers: buildGraphqlAuthHeaders(),
    credentials: "include",
    body: JSON.stringify({
      query: GET_ENTITY_ATTACHMENT_UPLOAD_URL,
      variables: { entityId, entityType, fileName, fileType, companyId: getUrqlTenantCompanyId() },
    }),
  });
  const result = await response.json();
  if (result.errors?.length) {
    throw new Error(result.errors[0]?.message || "Error al obtener URL de carga");
  }
  const payload = result.data?.getEntityAttachmentUploadUrl;
  if (!payload?.uploadUrl || !payload?.fileId) {
    throw new Error("Respuesta inválida del servidor (upload URL)");
  }
  return payload;
}

export async function fetchEntityAttachmentDownloadUrl({ entityId, entityType, fileName }) {
  const response = await fetch(getGraphqlUrl(), {
    method: "POST",
    headers: buildGraphqlAuthHeaders(),
    credentials: "include",
    body: JSON.stringify({
      query: GET_ENTITY_ATTACHMENT_DOWNLOAD_URL,
      variables: { entityId, entityType, fileName, companyId: getUrqlTenantCompanyId() },
    }),
  });
  const result = await response.json();
  if (result.errors?.length) {
    throw new Error(result.errors[0]?.message || "Error al obtener URL de descarga");
  }
  const url = result.data?.getEntityAttachmentDownloadUrl;
  return url ? toAbsoluteDownloadUrl(url) : url;
}
